import type { Orientation } from '@/types/constants';
import { ORIENTATIONS } from '@/utils/constants';
import { buildImageUrl } from '@/utils/images/build-image-url';

export type ImageConfig = {
    src: string;
    srcSet: string;
    sizes: string;
    alt: string;
    loading: 'eager' | 'lazy';
    fetchPriority: 'high' | 'low' | 'auto';
};

export const createImageConfig = (url: string, layoutVariant: Orientation): ImageConfig => {
    const baseConfig = {
        alt: 'Exclusive game background',
        loading: 'eager' as const,
        fetchPriority: 'high' as const
    };

    if (layoutVariant === ORIENTATIONS.PORTRAIT) {
        return {
            ...baseConfig,
            src: buildImageUrl(url, { auto: 'format', h: 93 }),
            srcSet: [
                `${buildImageUrl(url, { auto: 'format', w: 344, h: 193 })} 344w`,
                `${buildImageUrl(url, { auto: 'format', w: 516, h: 290 })} 516w`,
                `${buildImageUrl(url, { auto: 'format', w: 688, h: 387 })} 688w`,
                `${buildImageUrl(url, { auto: 'format', w: 1032, h: 580 })} 1032w`
            ].join(', '),
            sizes: ['(max-width: 344px) 344px', '(max-width: 516px) 516px', '(max-width: 688px) 688px', '1032px'].join(
                ', '
            )
        };
    }

    return {
        ...baseConfig,
        src: buildImageUrl(url, { auto: 'format', h: 579 }),
        srcSet: [
            `${buildImageUrl(url, { auto: 'format', w: 936, h: 579 })} 936w`,
            `${buildImageUrl(url, { auto: 'format', w: 1404, h: 600 })} 1404w`,
            `${buildImageUrl(url, { auto: 'format', w: 1478, h: 650 })} 1478w`,
            `${buildImageUrl(url, { auto: 'format', w: 1960, h: 720 })} 1960w`
        ].join(', '),
        sizes: [
            '(max-width: 936px) 100vw',
            '(max-width: 1200px) 936px',
            '(max-width: 1404px) 1404px',
            '(max-width: 1478px) 1478px',
            '1960px'
        ].join(', ')
    };
};
